import { Outlet } from "react-router"
import { PublishedPageGuard } from "source/shared/guards/PublishedPageGuard"
import { LAYOUT_WIDTHS } from "source/useRouteLayoutWidth"

export const handle = { layoutWidth: LAYOUT_WIDTHS.wide }

export default function RegistrationsLayout() {
  return (
    <PublishedPageGuard identifier="registrations">
      <Outlet />
    </PublishedPageGuard>
  )
}
